import { LABELS } from "~/resources/Labels";
import { getComponentNumber } from "~/Utils/Utils";
import { MESSAGES } from "~/resources/Message";
import { ComponentRequest } from "~/models/Commons ";
import { UseVmComponentsForm } from "./vm-configuration/UseVmComponentsForm";
import { SIMPLDialog } from "../../../components/commons/dialog/SimplDialog";
import { SIMPLInput } from "../../../components/commons/input/SIMPLInput";
import { SIMPLButtonCustomized } from "../../../components/commons/button/SIMPLButtonCustumized";

type DialogProps = {
  onSuccess?: (title: string, message: string, response: any) => void;
  onError?: (title: string, message: string) => void;
};
export type VmComponentType =
  | "vm-configuration"
  | "post-provisioning-operations"
  | "policies";

interface VmFormConfig {
  componentType: VmComponentType; // restringido aos valores válidos
  contentLabel: string; // label do textarea
  contentMessage: string; // mensagem de erro do textarea
}

interface Prop {
  onCloseModal: () => void;
  editedItem: ComponentRequest | null;
  setConfig: Function;
  refetch: () => void;
  title?: string;
  config: VmFormConfig;
  dialogProps: DialogProps;
}

export const AddVmGeneric = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  title,
  config,
  dialogProps: { onSuccess, onError },
}: Prop) => {
  const { handleSubmit, control, errors, submitForm } = UseVmComponentsForm(
    onCloseModal,
    refetch,
    onSuccess,
    onError,
  );

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit((formData: ComponentRequest) => {
      submitForm(formData, getComponentNumber(config.componentType));
    })(event);

    setConfig({ key: "", direction: LABELS.ASC });
  };

  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={onCloseModal}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized label={LABELS.Submit} primary />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={editedItem ? LABELS.EditScript : title!}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
      showLine
    >
      <div className="flex justify-center">
        <div className="w-[500px]">
          <div className="flex flex-col w-full gap-y-4">
            <SIMPLInput
              name="name"
              control={control}
              rules={{
                required: { value: true, message: LABELS.NameRequired },
              }}
              label={LABELS.Name}
              placeholder={LABELS.Name}
              required
              id="name"
              fontWeight="bold"
              errorLabel={errors.name?.message}
              testId="component-name"
            />
            <SIMPLInput
              name="description"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: MESSAGES.MessagesDescriptionRequired,
                },
              }}
              required
              label={LABELS.Description}
              id="description"
              fontWeight="bold"
              errorLabel={errors.description?.message}
              placeholder={LABELS.Description}
              testId="component-description"
            />
            <SIMPLInput
              name="content"
              control={control}
              type="textarea"
              rows={4}
              label={config.contentLabel}
              placeholder=""
              required
              rules={{
                required: { value: true, message: config.contentMessage },
              }}
              id="content"
              fontWeight="bold"
              errorLabel={errors.content?.message}
              testId="component-content"
            />
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
